import { useToast } from '../../state-management/contexts/ToastContext'
import { useEffect, useState } from 'react'
import { ToastBase } from './ToastBase'

interface ToastProps {
  width?: string
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top-center' | 'bottom-center'
  toastToBeShownById: string
  /** Distance above this host. Host itself takes no layout size. */
  bottomOffset?: number
}

/**
 * Screen/sheet toast host. Mount it where the toast should appear; the wrapper is h-0
 * and the bubble is position:absolute to that wrapper.
 *
 * showToast({ toastToBeShownById }) must match this id. Omit the id to use GlobalToast.
 */
export const LocalToast = ({
  width = '400px',
  toastToBeShownById,
  bottomOffset = 20
}: ToastProps) => {
  const { currentLocalToastId, isVisible, width: toastWidth } = useToast()
  const [shouldShow, setShouldShow] = useState(false)

  useEffect(() => {
    if (currentLocalToastId && currentLocalToastId === toastToBeShownById && isVisible) {
      setShouldShow(true)
    } else {
      setShouldShow(false)
    }
  }, [currentLocalToastId, toastToBeShownById, isVisible])

  return (
    <div className='relative w-full h-0'>
      <ToastBase
        width={toastWidth ?? width}
        style={{ bottom: `${bottomOffset}px` }}
        className={`${shouldShow ? 'opacity-100' : 'opacity-0'} absolute left-1/2 -translate-x-1/2`}
      />
    </div>
  )
}
